// extracted by mini-css-extract-plugin
module.exports = {"FooterWrapper":"Footer_FooterWrapper__hqReg"};